export const getEndpoints = environment => {
  switch (environment) {
    case 'PRODUCTION':
      return {
        TEACH_APP: 'https://teach-api.datacamp.com/teach-app'
      };
    case 'LOCAL':
    case 'TEST':
    case 'DEVELOPMENT':
      return {
        TEACH_APP: 'https://teach-api.datacamp-staging.com/teach-app'
      };
    default:
      return {
        TEACH_APP: 'https://teach-api.datacamp-staging.com/teach-app'
      };
  }
};